import { clearSessionToken } from "../../../shared/session/auth-token";

type UseSignOutOptions = {
  onSignedOut: () => void;
};

export function useSignOut({ onSignedOut }: UseSignOutOptions) {
  return function signOut() {
    clearSessionToken();
    onSignedOut();
  };
}
